<template>
	<div style="width: 100%">
		<v-tabs v-model="tab">
			<v-tab
				v-for="(n, i) in tabs"
				:to="'#' + n.value"
				:key="i+1"
			>
				{{n.name}}

			</v-tab>
			<v-spacer></v-spacer>
			<span class="balance" v-if="userName">
				{{ $t('personal_finance.user_name') }}: {{ userName }}
			</span>
			<span class="balance">
				{{ $t('personal_finance.balance_by_period') }}: {{ userBalanceByPeriod }} Kč
			</span>
			<span class="balance">
				{{ $t('personal_finance.balance') }}: {{ userBalance }} Kč
			</span>
			<v-tab-item
				v-for="(item, i) in tabs"
				:id="item.value"
				:key="i"
			>
				<v-card flat>
					<v-card-text>
						<v-layout>
							<v-flex md2>
								<Datepicker
									v-model="date.start"
									:label="$t('workers.date_start')"
								/>
							</v-flex>
							<v-flex md2>
								<Datepicker
									v-model="date.end"
									:label="$t('workers.date_end')"
								/>
							</v-flex>
							<v-flex md2>
								<v-btn @click="getByDate">
									{{$t('common.find')}}
								</v-btn>
							</v-flex>
							<v-flex md2>
								<div class="finance_sum">
									<h4>{{ $t('personal_finance.output') }}</h4>
									<h3>{{ totalSum.outputs }} Kč</h3>
								</div>
							</v-flex>
							<v-flex md2>
								<div class="finance_sum">
									<h4>{{ $t('personal_finance.input') }}</h4>
									<h3>{{ totalSum.inputs }} Kč</h3>
								</div>
							</v-flex>
							<v-flex md2>
								<div class="finance_sum">
									<h4>{{ $t('personal_finance.pay') }}</h4>
									<h3>{{ totalSum.pays }} Kč</h3>
								</div>
							</v-flex>
							<v-flex md2>
								<div class="finance_sum">
									<h4>{{ $t('payments_types.type_premium') }}</h4>
									<h3>{{ totalSum.premium }} Kč</h3>
								</div>
							</v-flex>
							<v-flex md2>
								<div class="finance_sum">
									<h4>{{ $t('payments_types.type_accommodation') }}</h4>
									<h3>{{ totalSum.accommodation }} Kč</h3>
								</div>
							</v-flex>
							<v-flex md2>
								<div class="finance_sum">
									<h4>{{ $t('payments_types.type_fare') }}</h4>
									<h3>{{ totalSum.fare }} Kč</h3>
								</div>
							</v-flex>
								<v-flex md2>
								<div class="finance_sum">
									<h4>{{ $t('payments_types.type_zp') }}</h4>
									<h3>{{ totalSum.zp }} Kč</h3>
								</div>
							</v-flex>
						</v-layout>
						<components
							:is="item.component"
							
							:editable="editable"
						/>
					</v-card-text>
				</v-card>
			</v-tab-item>
		</v-tabs>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import OtputFinance from './OutputFinance'
import InputFinance from './InputFinance'
import WorkerPay from './WorkerPay'
import Datepicker from '../../components/DatePicker'

export default {
	components: {
		Datepicker
	},
	data: vm => ({
		editable: true,
		tab: vm.$route.hash.replace(/^#/, '') || 'all',
		tabs: [
			{
				name: vm.$t('personal_finance.output'),
				component: OtputFinance,
				value: 'output',
			},
			{
				name: vm.$t('personal_finance.input'),
				component: InputFinance,
				value: 'input',
			},
			{
				name: vm.$t('personal_finance.workers_pay'),
				component: WorkerPay,
				value: 'worker_pay',
			}
		]
	}),
	methods: {
		...mapActions({
			fetchAll: 'finance/fetchAll',
			fetchUserFinanceAll: 'finance/fetchUserFinanceAll',

			fetchPersonalPays: 'reports/fetchPersonalPays',
			fetchPaysByUser: 'reports/fetchPaysByUser'
		}),
		changeAccess() {
			// on page personal show edit but when show for someone else - it's hidden
			if(this.hasRole('admin') && this.$route.params.userId) {
				this.fetchUserFinanceAll(this.$route.params.userId)
				this.fetchPaysByUser({userId: this.$route.params.userId, date: this.date})
				this.editable = false
			} else {
				this.fetchAll()
				this.fetchPersonalPays(this.date)
				this.editable = true
			}
		},
		getByDate() {
			this.changeAccess()
		}
	},
	created() {
		this.changeAccess()
	},
	computed: {
		...mapGetters({ hasRole: 'auth/hasRole' }),
		...mapState({
			userBalance: ({ finance }) => finance.userBalance,
			userName: ({ finance }) => finance.userName,
			date: ({ finance }) => finance.date,
			totalSum: ({ finance }) => finance.totalSum
		}),
		userBalanceByPeriod() {
			return (
				this.totalSum.inputs -
				this.totalSum.outputs -
				this.totalSum.pays -
				this.totalSum.premium
			).toFixed(2)
		}
	},
	watch: {
		'$route'() {
			this.changeAccess()
		}
	}
}
</script>

<style>
.balance {
	font-size: 18px;
	padding: 16px 20px;
	font-weight: bold;
}
.finance_sum {
	margin: 0 5px;
	text-align: center;
	border: 1px solid #949494;
	font-size: 13px;
}
</style>

